import storage from "components/Pixacom/storage";
import { createStore, applyMiddleware, compose } from "redux"
import createDebounce from "redux-debounced"
import thunk from "redux-thunk"
import rootReducer from "../reducers/rootReducer"

const middlewares = [thunk, createDebounce()]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  rootReducer,
  { auth: { login: { user: (storage.getItem('user') !== null ? JSON.parse(storage.getItem('user')) : ""), token: (storage.getItem('token') !== null ? storage.getItem('token') : "")} } },
  composeEnhancers(applyMiddleware(...middlewares))
)

export { store }
